import { ChangeEvent } from 'react';
import {
  Input,
  InputGroup,
  InputGroupText,
  Pagination,
  PaginationItem,
  PaginationLink,
} from 'reactstrap';

interface IProps {
  totalItems: number;
  selectedPage: number;
  totalPages: number;
  pages: number[];
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const DailyWorkloadPagination = ({
  totalItems,
  selectedPage,
  totalPages,
  pages,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}: IProps) => {
  return (
    <div className="d-flex align-items-center justify-content-between mt-3">
      <small className="text-muted">Total de {totalItems} registro(s)</small>

      <div
        className="d-flex align-items-center gap-3"
        style={{ minHeight: 38 }}
      >
        <InputGroup style={{ width: 160 }}>
          <InputGroupText
            className="text-muted fw-semibold"
            style={{ height: 38 }}
          >
            Exibir
          </InputGroupText>
          <Input
            id="rows-per-page"
            type="select"
            value={rowsPerPage}
            onChange={onRowsPerPageChange}
            style={{ height: 38 }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </Input>
        </InputGroup>

        <Pagination
          className="mb-0 d-flex align-items-center"
          style={{ height: 38, marginTop: 0, marginBottom: 0 }}
        >
          <PaginationItem disabled={selectedPage === 1}>
            <PaginationLink
              previous
              onClick={() => onPageChange(selectedPage - 1)}
            />
          </PaginationItem>

          {pages.map((page) => (
            <PaginationItem key={page} active={selectedPage === page}>
              <PaginationLink onClick={() => onPageChange(page)}>
                {page}
              </PaginationLink>
            </PaginationItem>
          ))}

          <PaginationItem disabled={selectedPage >= totalPages}>
            <PaginationLink
              next
              onClick={() => onPageChange(selectedPage + 1)}
            />
          </PaginationItem>
        </Pagination>
      </div>
    </div>
  );
};
